import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const {
    GET_CLIENT,
    ERROR_CLIENT,
    INSTANCE_RUNNING_STATUS
} = require('../Constants/client.constants');
const { createRequest } = require('../../api/client');

export const getClient = (tenantId) => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/clients/getClient`,
        methods: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        qs: {
            tenantId
        }
    };
    try {
        const data = await createRequest(options);
        dispatch({
            type: GET_CLIENT,
            data
        });
    } catch (err) {
        handleExcception(err);
        dispatch({
            type: ERROR_CLIENT,
            data: 'Error while fetch clients'
        });
    }
};

export const getInstanceRunningStatus = (hostname) => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/clients/getRunningStatus/${hostname}`,
        methods: 'GET'
    };
    try {
        const status = await createRequest(options);
        if (status.data) {
            status.data.map((s) => {
                s.name = s.service.charAt(0).toUpperCase() + s.service.slice(1);
                s.status = s.status === 'up' ? 'Operational' : 'Performance Degraded';
                return s;
            });
            dispatch({
                type: INSTANCE_RUNNING_STATUS,
                data: status.data
            });
        } else {
            dispatch({
                type: INSTANCE_RUNNING_STATUS,
                data: []
            });
        }
    } catch (err) {
        handleExcception(err);
        dispatch({
            type: INSTANCE_RUNNING_STATUS,
            data: []
        });
    }
};
